import { render } from "./versionManage.vue?vue&type=template&id=5d85976a&scoped=true&ts=true"
import script from "./versionManage.vue?vue&type=script&lang=ts"
export * from "./versionManage.vue?vue&type=script&lang=ts"

import "./versionManage.vue?vue&type=style&index=0&id=5d85976a&lang=scss&scoped=true"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d85976a"]])

export default __exports__